export type AssessmentTab = "residents" | "mds" | "care" | "agent";

interface TabNavigationProps {
  activeTab: AssessmentTab;
  onTabChange: (tab: AssessmentTab) => void;
  visibleTabs?: AssessmentTab[];
}

const tabs: { id: AssessmentTab; label: string; width: string }[] = [
  { id: "residents", label: "Residents", width: "140px" },
  { id: "mds", label: "MDS Assessments", width: "166.67px" },
  { id: "care", label: "Care Assessments", width: "165.91px" },
];

export function TabNavigation({ activeTab, onTabChange, visibleTabs }: TabNavigationProps) {
  const filteredTabs = visibleTabs
    ? tabs.filter((tab) => visibleTabs.includes(tab.id))
    : tabs;

  return (
    <div className="flex overflow-hidden">
      {filteredTabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`h-11 px-6 py-3 flex items-center justify-center text-sm font-bold whitespace-nowrap cursor-pointer border-b border-solid border-[#D1D2DB] ${
            activeTab === tab.id
              ? "bg-[#EDEDED] text-[#228189]"
              : "bg-transparent text-[#1B3647] hover:bg-gray-50"
          }`}
          style={{ width: tab.width, borderTop: 0, borderLeft: 0, borderRight: 0 }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
